export default "__VITE_ASSET__BrjffzSH__"